import { stationeryNumbers } from "../../../../data/stationery";
import { stdObject } from "../../../../data/types/stdObject";

export const convertPaperValue = (
  code: string,
  value: any,
  params: stdObject,
) => {
  const { docValues, setDocValues, handleActive } = params;
  if (code === "FOMDOC" && !value) {
    handleActive({ code: "FORMNUMBER", partType: 2 }, false);
  }
  docValues.data[code] = stationeryNumbers.includes(code)
    ? Number(value) * 100
    : value;
  setDocValues({ ...docValues });
  return true;
};
